import { NextPage } from 'next'
import React from 'react'
import { useIntl } from 'react-intl'

import { CartNavBar } from '@/components/Cart/CartNavBar'
import { BasicInvoice } from '@/components/Invoice/BasicInvoice'
import { DownloadPDF } from '@/components/Invoice/shared'
import { Meta } from '@/components/Meta/Meta'
import { routes } from '@/lib/routes'

interface Props {
  venueSlug: string
  orderId: string
}

const BasicInvoicePage: NextPage<Props> = ({ venueSlug, orderId }) => {
  const intl = useIntl()

  return (
    <>
      <Meta noindex nofollow title="Your receipt - me&u" />
      <CartNavBar
        title={intl.formatMessage({
          defaultMessage: 'Your receipt',
          id: 'I2rjk3',
        })}
      />
      <div className="h-14 w-full" />

      <div className="mx-auto max-w-[960px] p-4 sm:max-w-[1024px] md:max-w-[1200px]">
        <div className="mb-32">
          <BasicInvoice orderId={orderId} />
        </div>

        <DownloadPDF
          href={
            routes.invoicePdf.toPath &&
            routes.invoicePdf.toPath({ venueSlug, orderId })
          }
        />
      </div>
    </>
  )
}

BasicInvoicePage.getInitialProps = (ctx) => {
  const venueSlug = String(ctx.query.venueSlug).toLowerCase()
  const orderId = String(ctx.query.orderId)

  return { venueSlug, orderId }
}

export default BasicInvoicePage
